import { TranslatableString } from 'app/main/shared/model/translateble-string.model';

export class KeyValueDTO<T = string> {
    constructor(
        public id: string,
        public name?: string,
        public data?: T,
        public field1?: string,
        public field2?: string,
        public field3?: string,
        public translateName?: TranslatableString[],
        public order?: number,
        public active?: boolean
    ) {}
}
